// src/api/services/farm/farmService.js
import client from '../client';

const BASE = '/api/farms';

/** Get all farms*/
export function getFarms() {
  return client.get(BASE).then(res => res.data);
}

/** Get farm by id */
export function getFarmById(id) {
  return client.get(`${BASE}/${id}`).then(res => res.data);
}

/** Create farm */
export function createFarm(payload) {
  return client.post(BASE, payload).then(res => res.data);
}

/** Update farm */
export function updateFarm(id, payload) {
  return client.put(`${BASE}/${id}`, payload).then(res => res.data);
}

/** Update business hours */
export function updateBusinessHours(id, businessHours) {
  return client
    .patch(`${BASE}/${id}/business-hours`, { businessHours })
    .then(res => res.data);
}

/** Update tips */
export function updateTips(id, tips) {
  return client.patch(`${BASE}/${id}/tips`, { tips }).then(res => res.data);
}

/** Update location */
export function updateLocation(id, locationData) {
  return client.patch(`${BASE}/${id}/location`, locationData).then(res => res.data);
}

/** Delete farm */
export function deleteFarm(id, { deleteLocation = true, deleteImages = true } = {}) {
  return client
    .delete(`${BASE}/${id}`, {
      params: { deleteLocation, deleteImages },
    })
    .then(res => res.data);
}
